/* eslint-disable react/no-deprecated */
import $ from 'jquery';
import { Component } from 'react';
import WidgetContainer from 'legacy/javascripts/components/widget_container.es6.jsx';
import StellaError from 'legacy/javascripts/components/stella_error.es6.jsx';
import StellaLoading from 'legacy/javascripts/components/stella_loading.es6.jsx';
import DateRangePicker from 'legacy/javascripts/components/date_range_picker.es6.jsx';
import SubscriptionSettings from 'legacy/javascripts/components/subscription_settings.es6.jsx';

import widgets from 'legacy/javascripts/components/widgets';
import { shortUsaDateFormat } from 'common/utils/date';

class TeamTrends extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      dateRange: DateRangeQueryString.dateRange(),
    };
    this.refresh = this.refresh.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.onDateRangeApply = this.onDateRangeApply.bind(this);
  }

  componentDidMount() {
    this.refresh();
  }

  onDateRangeApply(_event, picker) {
    const dateRange = {
      start: picker.startDate,
      end: picker.endDate,
      label:
        picker.chosenLabel !== picker.locale.customRangeLabel
          ? picker.chosenLabel
          : undefined,
      solicitation_reporting_timestamp: picker.timestamp,
    };

    this.setState({ dateRange });
    this.refresh();
  }

  refresh() {
    DateRangeQueryString.setDateRange(this.state.dateRange, shortUsaDateFormat);

    this.setState({ loading: true });
    $.ajax({
      url: `${window.location.pathname}${window.location.search}`,
      cache: false,
      dataType: 'json',
      success: data => {
        data.loading = false;
        this.setState({
          ...data,
          dateRange: DateRangeQueryString.dateRange(),
        });
      },
      error: () => {
        this.setState({ error: true, loading: false });
      },
    });
  }

  handleModalOpen(evt) {
    this.setState({
      datasetKey: evt.target.closest('.widgetRow.channelData').dataset.channel,
    });
  }

  displayWidgets() {
    let dynamic_widget_width = Math.floor(
      12 / this.state.dynamic_widgets.length,
    );
    const hasChannelDataPerMember =
      this.state.team_members.data.datasets &&
      Object.keys(this.state.team_members.data.datasets).length > 1;

    return (
      <div className="team-trends">
        <div className="row">
          {this.state.dynamic_widgets.map((widget, i) => (
            <div key={`col-${i}`} className={`col-md-${dynamic_widget_width}`}>
              <WidgetContainer
                title={widget.label}
                data={widget.data}
                widget={widgets[widget.widgetName]}
                filters={this.state.filters}
                handler={this.handleModalOpen}
                questions={
                  widget.questionTab
                    ? this.state.filters.available_questions
                    : null
                }
                onApplyCallback={widget.questionTab ? this.refresh : null}
                widgetProps={{ hasChannelDataPerMember }}
              />
            </div>
          ))}
        </div>

        <div className="row">
          <div className="col-md-12">
            <WidgetContainer
              title={this.state.areasofimprovement.label}
              data={this.state.areasofimprovement.data}
              widget={widgets[this.state.areasofimprovement.klass]}
            />
          </div>
        </div>

        {!!this.state.areas_of_excellence && (
          <div className="row">
            <div className="col-md-12">
              <WidgetContainer
                title={this.state.areas_of_excellence.label}
                data={this.state.areas_of_excellence.data}
                widget={widgets[this.state.areas_of_excellence.klass]}
              />
            </div>
          </div>
        )}

        {this.state.team_members.data.datasets ? (
          <div className="row">
            <div className="col-md-12">
              <WidgetContainer
                title={this.state.team_members.label}
                data={this.state.team_members.data}
                widget={widgets[this.state.team_members.klass]}
                filters={this.state.filters}
              />
            </div>
          </div>
        ) : (
          <WidgetContainer
            title={this.state.team_members.label}
            widget="TeamMemberTrendsLink"
            data={{ teamId: this.state.team_id }}
          />
        )}

        <div className="js-team-area-drill modal fade">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-close close" data-dismiss="modal">
                ×
              </div>
              <WidgetContainer
                title={this.state.team_members_areas.label}
                data={this.state.team_members_areas.data}
                widget={widgets[this.state.team_members_areas.klass]}
                filters={this.state.filters}
                widgetProps={{ datasetKey: 'improvement', exportable: false }}
              />
            </div>
          </div>
        </div>

        {!!this.state.team_members_excellence && (
          <div className="js-team-excellence-drill modal fade">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-close close" data-dismiss="modal">
                  ×
                </div>
                <WidgetContainer
                  title={this.state.team_members_excellence.label}
                  data={this.state.team_members_excellence.data}
                  widget={widgets[this.state.team_members_excellence.klass]}
                  filters={this.state.filters}
                  widgetProps={{ datasetKey: 'excellence', exportable: false }}
                />
              </div>
            </div>
          </div>
        )}

        {hasChannelDataPerMember && (
          <div className="js-team-channel-drill modal fade">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-close close" data-dismiss="modal">
                  ×
                </div>
                <WidgetContainer
                  title={`${this.state.team_members.label}: ${this.state.datasetKey}`}
                  data={this.state.team_members.data}
                  widget={widgets[this.state.team_members.klass]}
                  filters={this.state.filters}
                  widgetProps={{
                    datasetKey: this.state.datasetKey,
                    hideTabs: true,
                    hasChannelDataPerMember,
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  apostrophize(name) {
    if (!name) return '';
    return name + (name[name.length - 1] === 's' ? "'" : "'s");
  }

  loadedComponents() {
    if (!this.state.loading && !this.state.error) {
      return <div>{this.displayWidgets()}</div>;
    }
  }

  render() {
    return (
      <div>
        <div className="team-trends-header">
          <div className="team-trends-header-wrap">
            {this.state.selected_employee?.image && (
              <div className="profile">
                <img
                  className="profile-img"
                  src={this.state.selected_employee?.image}
                />
              </div>
            )}
            <div className="info">
              <div className="name">
                <span data-notranslate>
                  {this.apostrophize(this.state.selected_employee?.label)}
                </span>{' '}
                Team
              </div>
              <div className="description">
                <span>Performance for </span>
                <label htmlFor="daterange" className="datepicker-wrapper">
                  <DateRangePicker
                    onApply={this.onDateRangeApply}
                    range={this.state.dateRange}
                  />
                </label>
              </div>
            </div>
          </div>
          {this.state.trends_emails && <SubscriptionSettings />}
        </div>
        <StellaLoading
          loading={this.state.loading}
          loadingImage={this.props.loading_image}
        />
        <StellaError
          error={this.state.error}
          errorImage={this.props.error_image}
        />
        {this.loadedComponents()}
      </div>
    );
  }
}

export default TeamTrends;
/* eslint-enable react/no-deprecated */
